document.addEventListener('DOMContentLoaded',function() {

    window.ytPlayer = function() {
        
        console.log('ytplayer');

        el = document.getElementsByClassName('js-yt');

        onYouTubeIframeAPIReady = function() {
    
            function onStateChange() {
                console.log('change');
            }
            
            var playerDivs = document.querySelectorAll('.js-ytplayer');
            
            // nodelist to array to use forEach();
            var playerDivsArr = [].slice.call(playerDivs);
            
            var players = new Array(playerDivsArr.length);
            
            playerDivsArr.forEach(function(e, i) {
                
                
                console.log(e.id);
                
                players[i] = new YT.Player(e.id, {
                    height: '390',
                    width: '640',
                    videoId: e.id,
                    playerVars: {
                        'playsinline': 0, 
                        'playlist': e.id,
                        'loop': 0, 
                        'modestbranding': 1,
                        'controls': 1,
                        'rel': 0,
                        'showinfo': 0,
                        'iv_load_policy': 3,
                    },
                    events: { 
                        'onReady': onPlayerReady,
                        'onStateChange': onPlayerStateChange
                    }
                })
            })
            
            function onPlayerReady(event) {
                console.log(event);
            }
            
            function onPlayerStateChange(event) {
                console.log('change');
                
                // if pause
                if (event.data === 2) {
                    event.target.f.parentNode.classList.remove('show-video');
                }            
            };
            
            const hideImgAndPlay = function(e) {
                console.log(e);
                e.currentTarget.classList.add('show-video');
                e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
            };
            
            for (let i = 0; i < el.length; i++) {
                el[i].addEventListener('click', function(e) {
                    
                    e.currentTarget.classList.add('show-video');
                    players[i].playVideo();
                });
            }
        }


            
        var tag = document.createElement('script');
        
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);   



    };
    
/*
    window.ytPlayer
    document.getElementsByClassName('js-ytplayer-auto').length > 0 ? window.ytPlayer() : false;
*/

}, false)